import { ActionPointsDTO} from "./action-points-configuration.model";
import { ActionPointType } from "./_enum/action-point.enum";

export class SaveActionPointsDTO {
    public actionPointToSave : ActionPointType

    /* Pensado para en un futuro hacer una carga masiva y no uno por uno*/
    public actionPointConfiguration : ActionPointsDTO

    constructor(actionPointToCreate : ActionPointType,
        actionPointConfiguration : ActionPointsDTO){
            this.actionPointToSave = actionPointToCreate;
            this.actionPointConfiguration = actionPointConfiguration;
    }
}
